import script from "./kapan.vue?vue&type=script&setup=true&lang=js"
export * from "./kapan.vue?vue&type=script&setup=true&lang=js"

import "./kapan.vue?vue&type=style&index=0&id=465142a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465142a4"]])

export default __exports__